import React from 'react';

export default ({children}) => {
  return (
    <form style={{height: '100%'}} onSubmit={e => e.preventDefault()}>
      {children}
    </form>
  );
};
